module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/**\n * A small range of wavelengths in the visible spectrum\n */\ndefine(function() {\n    SpectrumColor = function(color, startWavelength, endWavelength) {\n        this.color = color;\n        this.startWavelength = startWavelength;\n        this.endWavelength = endWavelength;\n    };\n    return SpectrumColor;\n});\n';

}
return __p
}